<div class="d-flex flex-row p-3" *ngrxLet="table$; let table">
    <div class="d-flex flex-column p-3">
        <div class="d-flex flex-row pb-2">
            <div class="pr-2">
                <div class="input-group">
                    <input
                        #globalFilterInput
                        type="text"
                        class="form-control"
                        placeholder="{{ 'CORE_BUTTON_SEARCH' | translate }}"
                        (input)="userTableDataSource?.setGlobalFilter?.(globalFilterInput.value)"
                        [disabled]="table.showSelectedUsers"
                    />
                    <div class="input-group-append">
                        <button
                            type="button"
                            class="btn btn-outline-secondary"
                            [disabled]="table.showSelectedUsers"
                            (click)="userTableDataSource?.clearGlobalFilterField?.(globalFilterInput)"
                        >
                            <i class="pi pi-times pl-2 pr-2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="user-table">
            <app-table [tableConfig]="userTableConfig!" [tableDataSource]="userTableDataSource!">
                <ng-template #header>
                    <tr>
                        <th id="selection" style="width: 4rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                        <th id="name">Name</th>
                        <th id="userName">{{ 'USERMANAGEMENT.TABLE_HEADING_USERNAME' | translate }}</th>
                        <th id="roles">{{ 'USERMANAGEMENT.TABLE_HEADING_ROLES' | translate }}</th>
                        <th id="lastLogin">{{ 'USERMANAGEMENT.TABLE_HEADING_LAST_LOGIN_DATE' | translate }}</th>
                        <th id="memberSince">{{ 'USERMANAGEMENT.TABLE_HEADING_MEMBER_SINCE' | translate }}</th>
                        <th id="userComment">{{ 'CORE.USER.COMMENT' | translate }}</th>
                        <th id="accountingComment">{{ 'CORE.ACCOUNTING.COMMENT' | translate }}</th>
                    </tr>
                </ng-template>
                <ng-template #body let-item let-rowIndex="rowIndex">
                    <tr [ngClass]="{ 'table-row-background': rowIndex % 2 == 1 }" [pSelectableRow]="item">
                        <td>
                            <p-tableCheckbox [value]="item"></p-tableCheckbox>
                        </td>
                        <td>{{ item.firstName }} {{ item.lastName }}</td>
                        <td>{{ item.userName }}</td>
                        <td>{{ translateRoles(item.roles) }}</td>
                        <td>{{ this.dateUtilsService.formatDate(item.lastLoginDate, DateUtilsService.DAY_MONTH_YEAR) }}</td>
                        <td>{{ this.dateUtilsService.formatDate(item.memberSince, DateUtilsService.DAY_MONTH_YEAR) }}</td>
                        <td>{{ item.comment || '-' }}</td>
                        <td>{{ item.accountingComment || '-' }}</td>
                    </tr>
                </ng-template>
            </app-table>
        </div>
    </div>
</div>
